import Api from '../services/api.js'

export default class BaseAction {
  constructor() {
    this.api = new Api();
    this.baseUrl = "/__api/v1"
  }

  composeUrl = (...paths) => {
    return this.baseUrl + paths.join("/").replace("//", "/");
  }

  requestDispatch = (action) => {
    return {
      type: action.request,
    };
  }

  successDispatch = (action, data) => {
    return {
      type: action.success,
      data: data,
    };
  }

  failureDispatch = (action, exception) => {
    return {
      type: action.failure,
      exception: exception,
    };
  }

  sendApiRequest = ({ method, action, url, params }) => {
    const apiRequest = this.api[method]
    return (dispatch) => {
      dispatch(this.requestDispatch(action));
      return apiRequest(url, params)
        .then(
          (response) => dispatch(this.successDispatch(action, response.data))
        )
        .catch(
          (err) => dispatch(this.failureDispatch(action, err))
        )
    }

  }

  apiGet = (action, url, params) => {
    const method = 'get';
    return this.sendApiRequest({ method, action, url, params })
  }

  apiPost = (action, url, params) => {
    const method = 'post';
    return this.sendApiRequest({ method, action, url, params })
  }

  apiPut = (action, url, params) => {
    const method = 'put';
    return this.sendApiRequest({ method, action, url, params })
  }

  apiDelete = (action, url, params) => {
    const method = 'delete';
    return this.sendApiRequest({ method, action, url, params })
  }

}


// WEBPACK FOOTER //
// ./src/actions/base_action.js